import { PROPS_RULES } from '../../_common/constants';

const getDataAttr = (props, rules, defaultRules) => {
  const finalRules = (rules || []).concat(defaultRules || PROPS_RULES.DEFAULT);
  return Object.keys(props).reduce((prev, key) => {
    const obj = prev;
    const ok = finalRules.some((rule) => {
      if (typeof rule === 'string') {
        return key === rule;
      } else if (toString.call(rule) === '[object RegExp]') {
        return rule.test(key);
      } else if (typeof rule === 'function') {
        return rule(key);
      }
      return false;
    });
    if (ok) obj[key] = props[key];
    return obj;
  }, {});
};
export default getDataAttr;
